<template>
  <div class="screen important" :class="[`${pageColor}-bg`]">
    <!--headline depends on the route-->
    <h1 v-if="currentOption === 'important'">focus on activities that are really important to you.</h1>
    <h1 v-else-if="currentOption === 'habits'">with each repitition an action becomes easier.</h1>
    <h1 v-else-if="currentOption === 'not-to-do'">what seems urgent isn’t necessarily important.</h1>
    <h1 v-else>This is not a valid list.</h1>
    <!--show todo list only if there are more than 0 todos-->
    <transition-group v-if="$store.state.loadedTodos.length > 0" class="todo-list" tag="div">
      <TodoItem
        class ="todo-item"
        :class="[pageColor]"
        v-for="todo in $store.state.loadedTodos"
        :createdAt="todo.createdAt"
        :done="todo.done"
        :category="todo.category"
        :timeNeeded="todo.timeNeeded"
        :timeExpected="todo.timeExpected"
        :dueDate="todo.dueDate"
        :id="todo.id"
        :key="todo.id"
        :project="todo.project"
        :motive="todo.motive"
        :text="todo.text"
        :icon="todo.icon"
        @edit-todo="$emit('edit-todo', $event)"
        @done="checkTodo(todo.id)"
      />
    </transition-group>
    <!-- empty state, show this if there are no todos -->
    <div v-if="$store.state.loadedTodos.length === 0" key="emptyState" @click="$emit('show-modal')">
      <div class="empty-state">
        <div class="start">
          <span>add new rhythms</span>
          <TodoIcon :icon="'down'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import TodoItem from '@/components/TodoItem.vue';
import TodoIcon from '@/components/TodoIcon.vue';

export default {
  name: 'category',
  components: {
    TodoItem,
    TodoIcon,
  },
  async created() {
    try {
      await this.$store.dispatch('loadTodosForCategory', this.currentOption); // load all todos for the current option
    } catch (err) {
      this.$store.commit('addToast', { message: `Sorry! An error occured when importing your todos in dependence of a list: ${err.message}` });
    }
  },
  computed: {
    currentOption() {
      return this.$route.params.option; // the current option is always the one which is selected by the dynamic route
    },
  },
  data() {
    return {
      todos: [],
      showDone: Boolean,
    };
  },
  methods: {
    checkTodo(todoId) {
      this.$store.dispatch('checkTodo', todoId); // call action in state to set todos to done
    },
    deleteTodo(todoId) {
      this.$store.dispatch('deleteTodo', todoId); // call delet action
      this.$store.commit('addToast', { message: 'Your rhythm has been deleted.' });
    },
    closeTodoModal() {
      this.todoBeingEdited = null;
      this.showTodoModal = false;
    },
  },
  props: {
    pageColor: String,
    option: String,
    todo: Object,
  },
};
</script>

<style lang="stylus" scoped>

@require '../assets/styles/breakpoints'

.screen
  margin: 0;
  padding: 0;
  background-image: linear-gradient(150deg, rgba(255,0,0,0), rgba(255,0,0,0), rgba(255,255,255,0.5), rgba(255,0,0,0), rgba(255,0,0,0))

  @media $desktop
    background-image: linear-gradient(-7deg, rgba(255,0,0,0), rgba(255,0,0,0), rgba(255,255,255,0.5), rgba(255,0,0,0), rgba(255,0,0,0))

  .todo-list
    border-bottom: solid 1px black

  .empty-state
    margin-left: 40px
    height: 60px
    color: black
    width: 85%

    .start
      display: flex
      position: absolute;
      right:0
      margin-bottom: 130px
      margin-right: 38px
      bottom: 0
      padding: 0px !important

      @media $desktop
        margin-bottom: 400px
        margin-right: 1150px

      @media $tablet
        margin-bottom: 330px
        margin-right: 880px

      span
        padding-right: 7px
        font-family: futura-pt, serif
        font-weight: 400
        font-style: normal
        text-transform: uppercase

      .icon
        padding-top: 3px
        color: black
        width: 18px
        height: 18px

        @media $tablet
          opacity: 0

</style>
